import styled, { css } from "styled-components";
import gridConfig from "../../../theme/grid-config";

interface Theme {
  breakpoints: Record<string, any>;
  mediaQuery: Record<string, (styles: string) => string>;
  rem: (value: number) => string;
}

interface StyledItemsGroupedProps {
  theme: Theme;
  $direction?: string | Record<string, string>;
  space?: number | Record<string, number>;
  fullWidth?: boolean | string[];
  isWrap?: boolean;
  align?: string | Record<string, string>;
  justify?: string | Record<string, string>;
}

export const StyledItemsGrouped = styled.div<StyledItemsGroupedProps>`
  display: flex;

  ${({ theme, justify }) => {
    if (justify) {
      return typeof justify === 'object'
        ? Object.entries(theme.breakpoints).map(([dim]) => justify[dim] && theme.mediaQuery[dim](`
            justify-content: ${justify[dim]};
          `))
        : `justify-content: ${justify};`
    }
    return 'justify-content: center;'
  }}

  ${({ theme, align }) => {
    if (align) {
      return typeof align === 'object'
        ? Object.entries(theme.breakpoints).map(([dim]) => align[dim] && theme.mediaQuery[dim](`
            align-items: ${align[dim]};
          `))
        : `align-items: ${align};`
    }
    return 'align-items: center;'
  }}

  ${({ theme, $direction }) => {
    if ($direction) {
      return typeof $direction === 'object'
        ? Object.entries(theme.breakpoints).map(([dim]) => $direction[dim] && theme.mediaQuery[dim](`
            flex-direction: ${$direction[dim]};
          `))
        : `flex-direction: ${$direction};`
    }
    return 'flex-direction: column;'
  }};

  ${({ theme, space, $direction }) => space && css`
    > *:not(:last-child) {
      ${typeof space === 'object'
        ? Object.entries(theme.breakpoints).map(([dim]) => $direction && $direction[dim] && theme.mediaQuery[dim](`
            margin-${$direction[dim] === 'row' ? 'right' : 'bottom'}: ${theme.rem(space[dim] || 8)};
            margin-${$direction[dim] === 'row' ? 'bottom' : 'right'}: 0;
          `))
        : `
          margin-right: ${theme.rem(space || 8)};
        `}
    }
  `}

  ${({ theme, fullWidth }) => fullWidth && css`
    ${Array.isArray(fullWidth)
      ? Object.entries(theme.breakpoints).map(([dim]) => theme.mediaQuery[dim] && theme.mediaQuery[dim](`
          width: ${fullWidth.indexOf(dim) !== -1 ? '100%' : 'auto'};
        `))
      : 'width: 100%;'}
  `}

  ${({ isWrap }) => isWrap && css`
    flex-wrap: wrap;
    row-gap: ${({ theme }) => theme.rem(16)};
  `}
`
